<template>
    <div class="pro-adv">
        <section class="adv-one">
            <div class="container">
                <h2 class="rx-title text-center" style="margin-bottom:50px;">{{titleOne}}</h2>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon1.png">
                            </div>
                            <h3>数据可视化</h3>
                            <p>多维视图展示</p>
                            <p>随时随地纵览全局</p>
                            <p>申办方、项目管理者必备</p>
                        </el-card>
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon2.png">
                            </div>
                            <h3>文档协作</h3>
                            <p>组件化、模板化的复用</p>
                            <p>完美的编辑体验</p>
                            <p>批注留痕、电子签名、溯源与版本管理</p>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon3.png">
                            </div>
                            <h3>AI智能化</h3>
                            <p>自动采集数据</p>
                            <p>自动填充、核查数据</p>
                            <p>全自动脱敏</p>
                        </el-card>
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon4.png">
                            </div>
                            <h3>源/电子数据采集</h3>
                            <p>中心/访视/库表管理</p>
                            <p>源数据变更感知</p>
                            <p>跨访视跨表单规则设置</p>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="box-card mostadv-card">
                            <div class="most-adv"  :style="{backgroundImage: 'url(' + ballimg + ')','background-repeat':'no-repeat','background-size':'auto','background-position':'bottom right',}">
                                <h3  class="text-center">全栈式解决方案</h3>
                                <p>面向临床研究项目过程管理的综合管理平台，负责项目总体进度把控、过程任务跟踪、项目过程文档管理、统计分析等</p>
                                <p>面向受试者的临床数据采集系统，包括源数据采集和临床数据采集及处理，以及智能化的SDC到EDC数据源的自动映射。</p>
                                <p>底层数据汇聚和动态分析形成项目全流程可视化跟踪，支持信息下钻、风险提示，管理者、PM通过看板即可对项目情况全盘掌握。</p>
                                <p class="text-left" style="margin-top:30px;text-indent:0;"><el-link type="primary">查看全部解决方案</el-link></p>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon5.png">
                            </div>
                            <h3>药物警戒</h3>
                            <p>基于E2B R3规范</p>
                            <p>支持自动上报CDE网关</p>
                            <p>基于低代码平台打造</p>
                        </el-card>
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon6.png">
                            </div>
                            <h3>成本分析</h3>
                            <p>基于项目报价和任务工时、资源矩阵的成本分析管理</p>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon7.png">
                            </div>
                            <h3>任务协作</h3>
                            <p>全流程的项目任务构建、派发与跟踪</p>
                            <p>完善的工时与成本分析</p>
                            <p>极致的用户体验</p>
                        </el-card>
                        <el-card class="box-card adv-card">
                            <div class="adv-icon">
                                <img src="@/assets/img/adv_icon8.png">
                            </div>
                            <h3>项目管理</h3>
                            <p>全流程数字化项目管理</p>
                            <p>支持风险管理、培训管理、SAE/AE管理、统计分析报告</p>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="mb-30">
            <div class="container">
                <h2 class="rx-title text-center">{{titleTwo}}</h2>
                <el-row :gutter="30" >
                    <el-col :span="6" v-for="option in options" :key="option.id">
                        <div class="advantage text-center"><img :src="option.src"></div>
                        <h3>{{ option.title }}</h3>
                        <p>{{ option.content }}</p>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="adv-three" :style="{backgroundImage: 'url(' + backimg + ')','background-repeat':'no-repeat','background-size':'auto','background-position':'center bottom',}">
            <div class="container">
                <h2 class="text-center">{{titleThree}}</h2>
                <p class="text-center">仁迅科技针对临床试验不同用户所涉及到的所有场景都进行了细致充分的考虑，</p>
                <p class="text-center" style="margin-bottom:30px;">一个账号，即可以便捷使用Android、IOS、PC、可视化等应用场景。</p>
                <el-row :gutter="30">
                    <el-col :span="8" v-for="scenes in sceness" :key="scenes.index">
                        <div class="scenes text-center"><img :src="scenes.src"></div>
                    </el-col>
                </el-row>
            </div>
        </section>
    </div>
</template>
<script>
  // Import Swiper styles
export default {
    data() {
        return {
            titleOne:'临床研究项目管理全生命周期的全栈解决方案',
            titleTwo:'方案优势',
            titleThree:'iTrial Genies ，多平台多场景应用',
            ballimg: require('../../../assets/img/ballbg.png'),
            backimg: require('../../../assets/img/line.png'),
            options: [{
                src: require('../../../assets/img/s1.jpg'),
                title: '强大的技术优势',
                content: '融合业界专家的知识库，全面采用新技术、新理念进行构建，平台架构灵活、易用且智能。',
                }, {
                src: require('../../../assets/img/s2.jpg'),
                title: '强大的可视化管理能力',
                content: '平台提供了自上而下的可视化运营与管理能力，直观、便捷、美观。',
                }, {
                src: require('../../../assets/img/s3.jpg'),
                title: '构建全链条产业生态',
                content: '基于技术与服务，建立机构与机构之间、机构与用户之间的强连接，助力全方位、全生命周期的大健康产业发展。',
                }, {
                src: require('../../../assets/img/s4.jpg'),
                title: '丰富的产品及解决方案',
                content: '采用新技术新方法，对行业进行数字化赋能，建设用来支撑临床研究项目管理全生命周期的智能化临床研究平台。',
                }
            ],
            sceness: [{
                src: require('../../../assets/img/scenes1.png')
                }, {
                src: require('../../../assets/img/scenes2.png')
                }, {
                src: require('../../../assets/img/scenes3.png')
                }
            ],
            clients: [{
                title: '客户一',
                src: require('../../../assets/img/partner/p_1.jpg')
                }, {
                title: '客户二',
                src: require('../../../assets/img/partner/p_2.jpg')
                }, {
                title: '客户三',
                src: require('../../../assets/img/partner/p_3.jpg')
                }
            ],
        };
    },
};
</script>
<style scoped>
.mb-30{
    margin-bottom: 30px;
}
.client-pic{
    height: 100px;
    display: flex;
	justify-content: center; 
	align-items: center; 
    border: 1px solid #eee;
    margin-bottom: 10px;
}
.client-pic img{
    max-width: 80%;
    max-height: 60px;
}
.advantage{
    display: flex;
	justify-content: center; 
	align-items: center; 
}
.advantage img{
    max-height: 100px;
}
.advantage p{
    font-size: 14px;
}
.scenes{
    background: rgba(0,0,0,0.2);
    padding: 30px;
    border-radius: 15px;
}
.scenes img{
    max-height: 200px;
}
.adv-one{
    background: #242933;
    padding: 30px 0;
    color: #fff;
}
.adv-three{
    background-color: #242933;
    color: #fff;
    padding: 10px 0 50px;

}
.el-card{
    background: none;
    border:none;
    color:#fff;
}
.el-card__body{
    background: -webkit-linear-gradient(#242933, #292F3B); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(#242933, #292F3B); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(#242933, #292F3B); /* Firefox 3.6 - 15 */
    background: linear-gradient(#242933, #292F3B); /* 标准的语法 */
    color:#fff;
    border:none;
}
.adv-card{
    margin-bottom: 40px;
    overflow: visible;
    height: 250px;
}
.adv-card h3{
    text-align: center;
}
.adv-card p{
    font-size: 14px;
    margin-bottom: 15px;
}

.most-adv{
    background: #1A1E26;
    height: 470px;
    padding: 30px 20px 0;
}
.most-adv p{
    text-align: left;
    line-height: 1.8;
    text-indent: 2em;
    margin-bottom: 20px;
}
.adv-icon{
    text-align: center;
    margin-top: -50px;
}
.adv-icon img{
    height: 50px;
    width: auto;
}
</style>